import { useCallback } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { OrganizationFeatureFlag } from '../enums/organizationFeatureFlag'
import { fetchOrganizationFeatureFlags } from '../query-api'
import { getOrganizationFeatureFlagKey } from '../utils/getOrganizationFeatureFlagKey'

export const useOrganizationFeatureFlags = () => {
  const { organization } = useUserOrganization()
  const { data, ...rest } = useQuery(
    [QueryKeys.OrganizationFeatureFlags, organization?.id],
    () => fetchOrganizationFeatureFlags(organization?.id || ''),
    { enabled: !!organization?.id },
  )

  const hasFeatureFlag = useCallback(
    (featureFlag: OrganizationFeatureFlag) => data?.settings[getOrganizationFeatureFlagKey(featureFlag)] === '1',
    [data?.settings],
  )

  return { hasFeatureFlag, ...rest }
}
